export const PROJECTS = [
	{
		title: 'Clinibase CTMS',
		desc: "Australia's most advanced Clinical Trial Management System — built for the nation's largest clinical trials company. Streamlines trial workflows, site management, participant tracking and regulatory compliance at scale.",
		technologies: [
			'React',
			'NextJS',
			'TypeScript',
			'GraphQL',
			'Hasura',
			'PostgreSQL',
			'AWS',
			'TailwindCSS',
		],
		image: 'clinibase-ctms.jpg',
	},
	{
		title: 'Clinibase Pulse',
		desc: 'Real-time clinical trial monitoring dashboard giving sponsors and CROs live visibility into trial health, site performance and data quality metrics — all in one intuitive interface.',
		technologies: [
			'React',
			'NextJS',
			'TypeScript',
			'GraphQL',
			'Hasura',
			'AWS',
			'TailwindCSS',
			'PostgreSQL',
		],
		image: 'clinibase-pulse.jpg',
	},
	{
		title: 'Encoo Connect',
		desc: 'A platform connecting healthcare professionals and clinical trial sites, enabling seamless collaboration, document sharing and communication across distributed research teams.',
		technologies: [
			'React',
			'NextJS',
			'TypeScript',
			'GraphQL',
			'NodeJS',
			'PostgreSQL',
			'AWS',
		],
		image: 'encoo-connect.jpg',
	},
	{
		title: 'Dealty',
		desc: 'Website to find your dream home',
		technologies: [
			'React',
			'Redux',
			'TailwindCSS',
			'NodeJS',
			'Express',
			'PostgreSQL',
			'TypeORM',
			'Migrations',
			'Google Domains',
			'Digital Ocean',
		],
		liveLink: 'https://yourdealty.com/',
		image: 'dealty.JPG',
	},
	{
		title: 'Spark Dev',
		desc: 'Consulting Company Portfolio',
		technologies: ['HTML', 'CSS', 'Javascript', 'Dark Mode'],
		liveLink: 'https://spark.dev/',
		image: 'spark.JPG',
	},
	{
		title: 'Stable',
		desc: 'Managing volatile prices and supply chain risks is hard. Stable makes it easy for you to protect your own business on your own terms.',
		technologies: [
			'React',
			'Redux',
			'TailwindCSS',
			'NodeJS',
			'Express',
			'PostgreSQL',
			'TypeORM',
			'Migrations',
			'Google Domains',
			'Digital Ocean',
		],
		liveLink: 'https://www.stableclub.com/',
		image: 'stable.JPG',
	},
	{
		title: 'Sarban Foundation Organisation',
		desc: 'Online Donation System for students who want to pursue higher education but cant afford',
		technologies: [
			'React',
			'Redux',
			'Bootstrap',
			'NodeJS',
			'Express',
			'PostgreSQL',
			'TypeORM',
			'Migrations',
			'Stripe',
		],
		liveLink: 'https://sarbanfoundation.org/',
		image: 'sarban.jpg',
	},
	{
		title: 'Cupet App',
		desc: 'A new innovative way to visualise spendings for couples!',
		technologies: [
			'React',
			'Redux',
			'TailwindCSS',
			'NodeJS',
			'Express',
			'PostgreSQL',
			'TypeORM',
			'Migrations',
			'PlaidAPI',
			'ClerkAPI',
			'Google Domains',
			'Digital Ocean',
		],
		image: 'cupet.jpg',
	},
	{
		title: 'Hadariat Contracting and General Management',
		desc: 'Portfolio Website for a contracting company in Abu Dhabi',
		technologies: ['React', 'Redux', 'Bootstrap'],
		liveLink: 'https://hcgm-ae-e2c94.web.app/',
		image: 'hadariat.jpg',
	},
	{
		title: 'Chetohs Personal CRM',
		desc: 'An online Customer Relationship Management system for personal use.',
		technologies: [
			'React',
			'Redux',
			'Bootstrap',
			'NodeJS',
			'Express',
			'MongoDB',
		],
		image: 'chetohs.jpg',
	},
	{
		title: 'Proshop Ecommerce Website',
		desc: 'An online Selling Marketplace',
		technologies: [
			'React',
			'Redux',
			'Bootstrap',
			'NodeJS',
			'Express',
			'MongoDB',
		],
		image: 'proshop.jpg',
	},
	{
		title: 'Snacks on Board',
		desc: 'An online food store, which tracks food truck locations near you, allowing you to place orders',
		technologies: [
			'Express Handlebars',
			'Bootstrap',
			'NodeJS',
			'Express',
			'MongoDB',
		],
		image: 'snacks.jpg',
	},
	{
		title: 'University of Melbourne Subject Review',
		desc: "University's first ever official review website, designed to help professors understand gaps in their subjects",
		technologies: ['PHP', 'mySQL', 'HTML5', 'CSS3', 'Javascript'],
		liveLink: 'https://www.subject-review.com/login/login.php',
		image: 'unimelb.jpg',
	},
]

export const LANGUAGES = [
	{ name: 'React', icon: 'devicon-react-original' },
	{ name: 'NextJS', icon: 'devicon-nextjs-original' },
	{ name: 'Javascript', icon: 'devicon-javascript-plain' },
	{ name: 'TypeScript', icon: 'devicon-typescript-plain' },
	{ name: 'Python', icon: 'devicon-python-plain' },
	{ name: 'Flask', icon: 'devicon-flask-original' },
	{ name: 'NodeJS', icon: 'devicon-nodejs-plain' },
	{ name: 'Express', icon: 'devicon-express-original-wordmark' },
	{ name: 'GraphQL', icon: 'devicon-graphql-plain' },
	{ name: 'Hasura', svg: '/images/hasura.svg' },
	{ name: 'PostgreSQL', icon: 'devicon-postgresql-plain' },
	{ name: 'MongoDB', icon: 'devicon-mongodb-plain' },
	{ name: 'mySQL', icon: 'devicon-mysql-plain' },
	{ name: 'AWS', icon: 'devicon-amazonwebservices-original' },
	{ name: 'Redux', icon: 'devicon-redux-original' },
	{ name: 'Github', icon: 'devicon-github-original' },
	{ name: 'Firebase', icon: 'devicon-firebase-plain' },
	{ name: 'DigitalOcean', icon: 'devicon-digitalocean-plain' },
	{ name: 'Bootstrap', icon: 'devicon-bootstrap-plain' },
	{ name: 'Dart', icon: 'devicon-dart-plain' },
	{ name: 'ThreeJS', icon: 'devicon-threejs-original' },
]

export const AI_TOOLS = [
	{
		name: 'Claude',
		company: 'Anthropic',
		desc: 'Advanced reasoning, code generation and long-context analysis for complex engineering problems.',
		gradient: 'from-orange-500/20 to-amber-500/20',
		border: 'border-orange-500/30',
		accent: 'text-orange-400',
		badge: 'bg-orange-500/15 text-orange-300 border-orange-500/25',
		initial: 'C',
		initialBg: 'bg-gradient-to-br from-orange-500 to-amber-500',
	},
	{
		name: 'ChatGPT',
		company: 'OpenAI',
		desc: 'Versatile language model used for ideation, debugging assistance, documentation and rapid prototyping.',
		gradient: 'from-emerald-500/20 to-teal-500/20',
		border: 'border-emerald-500/30',
		accent: 'text-emerald-400',
		badge: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/25',
		initial: 'G',
		initialBg: 'bg-gradient-to-br from-emerald-500 to-teal-500',
	},
	{
		name: 'Gemini',
		company: 'Google',
		desc: 'Multimodal AI for processing images, documents and data analysis across research and development workflows.',
		gradient: 'from-blue-500/20 to-violet-500/20',
		border: 'border-blue-500/30',
		accent: 'text-blue-400',
		badge: 'bg-blue-500/15 text-blue-300 border-blue-500/25',
		initial: 'G',
		initialBg: 'bg-gradient-to-br from-blue-500 to-violet-500',
	},
]
